import React, { useCallback, useState } from 'react';
import {
  ISSUE_ACTION_RES_OPTIONS,
  ISSUE_ACTION_RES_TYPES,
} from '../defineTdm';
import { IssueService } from './issueService';
import { modalContentStyle } from '../../js/components/modal/Modal';
import { Modal } from '@flightstats/airframe-react';
import { BatchResolveProps } from './types';

const CheckboxField: React.FC<{
  label: string;
  checked: boolean;
  onChange: () => void;
  className?: string;
}> = ({ label, checked, onChange, className = 'col-md-12' }) => (
  <div className={className}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    {label}
  </div>
);

const TabContent: React.FC<{
  resolutionOptions: Array<{ name: string; value: string }>;
  resolution: string;
  setResolution: (value: string) => void;
  extraMinutesAdded: string;
  setExtraMinutesAdded: (value: string) => void;
  extraMinutesAvoided: string;
  setExtraMinutesAvoided: (value: string) => void;
  travelerContacted: boolean;
  setTravelerContacted: (value: boolean) => void;
  pnrUpdated: boolean;
  setPnrUpdated: (value: boolean) => void;
  flightsChanged: boolean;
  setFlightsChanged: (value: boolean) => void;
  groundTransportationChanged: boolean;
  setGroundTransportationChanged: (value: boolean) => void;
  hotelChanged: boolean;
  setHotelChanged: (value: boolean) => void;
  newFlightsOnSameCarrier: boolean;
  setNewFlightsOnSameCarrier: (value: boolean) => void;
  ratePaidInUsDollars: string;
  setRatePaidInUsDollars: (value: string) => void;
  overnightAvoided: boolean;
  setOvernightAvoided: (value: boolean) => void;
  comment: string;
  setComment: (value: string) => void;
  formValid: boolean;
  onSubmit: () => void;
  rebookedTabOpen?: boolean;
  reprotectedTabOpen?: boolean;
  noChangesMadeTabOpen?: boolean;
  expiredTabOpen?: boolean;
}> = ({
  resolutionOptions,
  resolution,
  setResolution,
  extraMinutesAdded,
  setExtraMinutesAdded,
  extraMinutesAvoided,
  setExtraMinutesAvoided,
  travelerContacted,
  setTravelerContacted,
  pnrUpdated,
  setPnrUpdated,
  flightsChanged,
  setFlightsChanged,
  groundTransportationChanged,
  setGroundTransportationChanged,
  hotelChanged,
  setHotelChanged,
  newFlightsOnSameCarrier,
  setNewFlightsOnSameCarrier,
  ratePaidInUsDollars,
  setRatePaidInUsDollars,
  overnightAvoided,
  setOvernightAvoided,
  comment,
  setComment,
  formValid,
  onSubmit,
  noChangesMadeTabOpen = false,
  rebookedTabOpen = false,
  reprotectedTabOpen = false,
}) => (
  <div>
    <form role="form" onSubmit={onSubmit} noValidate>
      <div className="content">
        <div className="choices">
          <div className="row">
            <div className="col-md-3 fs-label fs-label-hxs hidden-sm hidden-xs">
              SUB RESOLUTION
            </div>
            <div className="col-md-3 fs-label fs-label-xs visible-sm visible-xs">
              SUB RESOLUTION
            </div>
            <div className="col-md-9 left">
              {resolutionOptions.map((option, index) => (
                <div className="col-md-4" key={index}>
                  <input
                    type="radio"
                    id={option.value}
                    name="subRes"
                    value={option.value}
                    className="mousetrap"
                    checked={resolution === option.value}
                    onChange={() => setResolution(option.value)}
                  />
                  {option.name}
                </div>
              ))}
            </div>
          </div>

          <div className="row field-sep">
            <div className="col-md-3 fs-label fs-label-hxs hidden-sm hidden-xs">
              FURTHER DETAILS
            </div>
            <div className="col-md-3 fs-label fs-label-xs visible-sm visible-xs">
              FURTHER DETAILS
            </div>
            <div className="col-md-9 left">
              <div className="row">
                <div className="col-md-6">
                  <div className="col-md-5">Extra Mins Added</div>
                  <div className="col-md-7">
                    <input
                      type="number"
                      value={extraMinutesAdded}
                      onChange={e => setExtraMinutesAdded(e.target.value)}
                      maxLength={4}
                    />
                  </div>
                </div>
                {(rebookedTabOpen || reprotectedTabOpen) && (
                  <CheckboxField
                    label="Overnight Avoided"
                    checked={overnightAvoided}
                    onChange={() => setOvernightAvoided(!overnightAvoided)}
                    className="col-md-6"
                  />
                )}
                {noChangesMadeTabOpen && (
                  <CheckboxField
                    label="Traveler Contacted"
                    checked={travelerContacted}
                    onChange={() => setTravelerContacted(!travelerContacted)}
                    className="col-md-6"
                  />
                )}
              </div>

              <div className="row">
                {(rebookedTabOpen || reprotectedTabOpen) && (
                  <div className="col-md-6">
                    <div className="col-md-5">Extra Mins Avoided</div>
                    <div className="col-md-7">
                      <input
                        type="number"
                        value={extraMinutesAvoided}
                        onChange={e => setExtraMinutesAvoided(e.target.value)}
                        maxLength={4}
                      />
                    </div>
                  </div>
                )}
                <div className="col-md-6">
                  {rebookedTabOpen && (
                    <>
                      <div className="col-md-3">Rate Paid</div>
                      <div className="col-md-9">
                        <input
                          type="number"
                          value={ratePaidInUsDollars}
                          onChange={e => setRatePaidInUsDollars(e.target.value)}
                          maxLength={7}
                        />
                        &nbsp;(in US Dollars)
                      </div>
                    </>
                  )}
                </div>
              </div>
              {(rebookedTabOpen || reprotectedTabOpen) && (
                <>
                  <div className="row field-sep">
                    <CheckboxField
                      label="Traveler Contacted"
                      checked={travelerContacted}
                      onChange={() => setTravelerContacted(!travelerContacted)}
                      className="col-md-12"
                    />
                  </div>

                  <div className="row">
                    <CheckboxField
                      label="PNR Updated"
                      checked={pnrUpdated}
                      onChange={() => setPnrUpdated(!pnrUpdated)}
                      className="col-md-6"
                    />
                    <CheckboxField
                      label="Flights Changed"
                      checked={flightsChanged}
                      onChange={() => setFlightsChanged(!flightsChanged)}
                      className="col-md-6"
                    />
                  </div>

                  <div className="row">
                    <CheckboxField
                      label="Hotel Changed"
                      checked={hotelChanged}
                      onChange={() => setHotelChanged(!hotelChanged)}
                      className="col-md-6"
                    />
                    <CheckboxField
                      label="New Flights on Same Carrier"
                      checked={newFlightsOnSameCarrier}
                      onChange={() =>
                        setNewFlightsOnSameCarrier(!newFlightsOnSameCarrier)
                      }
                      className="col-md-6"
                    />
                  </div>
                  <div className="row">
                    <CheckboxField
                      label="Ground Transportation Changed"
                      checked={groundTransportationChanged}
                      onChange={() =>
                        setGroundTransportationChanged(
                          !groundTransportationChanged,
                        )
                      }
                      className="col-md-12"
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="row field-sep">
            <div className="col-md-3 fs-label fs-label-hxs hidden-sm hidden-xs">
              COMMENT
            </div>
            <div className="col-md-3 fs-label fs-label-xs visible-sm visible-xs">
              COMMENT
            </div>
            <div className="col-md-9">
              <textarea
                value={comment}
                onChange={e => setComment(e.target.value)}
                required
                rows={5}
                className='text-area'
              />
            </div>
          </div>
        </div>

        <div className="action">
          <button
            className="btn btn-default button-action"
            type="submit"
            disabled={formValid}
          >
            RESOLVE
          </button>
        </div>
      </div>
    </form>
  </div>
);

const TabButton: React.FC<{
  label: string;
  isActive: boolean;
  onClick: () => void;
  className?: string;
}> = ({ label, isActive, onClick, className }) => (
  <div className="col-md-3">
    <div className="btn-wrapper">
      <button
        className={`btn ${isActive ? 'btn-active' : 'btn-inactive'} ${className}`}
        onClick={onClick}
      >
        {label}
      </button>
    </div>
  </div>
);

const BatchResolve: React.FC<BatchResolveProps> = ({ issues, cancel, issuesUpdated }) => {
  const [resolution, setResolution] = useState<string>('');
  const [extraMinutesAdded, setExtraMinutesAdded] = useState<string>('');
  const [extraMinutesAvoided, setExtraMinutesAvoided] = useState<string>('');
  const [travelerContacted, setTravelerContacted] = useState<boolean>(false);
  const [pnrUpdated, setPnrUpdated] = useState<boolean>(false);
  const [flightsChanged, setFlightsChanged] = useState<boolean>(false);
  const [
    groundTransportationChanged,
    setGroundTransportationChanged,
  ] = useState<boolean>(false);
  const [hotelChanged, setHotelChanged] = useState<boolean>(false);
  const [newFlightsOnSameCarrier, setNewFlightsOnSameCarrier] = useState<
    boolean
  >(false);
  const [ratePaidInUsDollars, setRatePaidInUsDollars] = useState<string>('');
  const [overnightAvoided, setOvernightAvoided] = useState<boolean>(false);
  const [comment, setComment] = useState<string>('');

  const [rebookedTabOpen, setRebookedTabOpen] = useState<boolean>(false);
  const [reprotectedTabOpen, setReprotectedTabOpen] = useState<boolean>(false);
  const [noChangesMadeTabOpen, setNoChangesMadeTabOpen] = useState<boolean>(
    false,
  );
  const [expiredTabOpen, setExpiredTabOpen] = useState<boolean>(true);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [formValid, setFormValid] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const resolutionOptionsRebooked = Object.entries(
    ISSUE_ACTION_RES_OPTIONS.rebooked,
  ).map(([key, value]) => ({ name: value, value: key }));
  const resolutionOptionsReprotected = Object.entries(
    ISSUE_ACTION_RES_OPTIONS.reprotected,
  ).map(([key, value]) => ({ name: value, value: key }));
  const resolutionOptionsNoAction = Object.entries(
    ISSUE_ACTION_RES_OPTIONS.no_changes_made,
  ).map(([key, value]) => ({ name: value, value: key }));
  const resolutionOptionsExpired = Object.entries(
    ISSUE_ACTION_RES_OPTIONS.expired,
  ).map(([key, value]) => ({ name: value, value: key }));

  const tabClicked = useCallback((tab: string) => {
    setRebookedTabOpen(tab === 'rebooked');
    setReprotectedTabOpen(tab === 'reprotected');
    setNoChangesMadeTabOpen(tab === 'noChangesMade');
    setExpiredTabOpen(tab === 'expired');
  }, []);

  const onSubmit = useCallback(async () => {
    setSubmitted(true);
    let options: any = {};

    if (rebookedTabOpen || reprotectedTabOpen) {
      options.type = rebookedTabOpen
        ? ISSUE_ACTION_RES_TYPES.rebooked
        : ISSUE_ACTION_RES_TYPES.reprotected;
      options.subResolution = resolution;
      options.extraMinutesAdded = extraMinutesAdded;
      options.extraMinutesAvoided = extraMinutesAvoided;
      options.travelerContacted = travelerContacted;
      options.pnrUpdated = pnrUpdated;
      options.flightsChanged = flightsChanged;
      options.groundTransportationChanged = groundTransportationChanged;
      options.hotelChanged = hotelChanged;
      options.newFlightsOnSameCarrier = newFlightsOnSameCarrier;
      options.overnightAvoided = overnightAvoided;
      if (rebookedTabOpen) {
        options.ratePaidInUsDollars = ratePaidInUsDollars;
      }
    } else {
      options.type = noChangesMadeTabOpen
        ? ISSUE_ACTION_RES_TYPES.no_changes_made
        : ISSUE_ACTION_RES_TYPES.expired;
      options.subResolution = resolution;
      options.extraMinutesAdded = extraMinutesAdded;
      if (noChangesMadeTabOpen) {
        options.travelerContacted = travelerContacted;
      }
    }

    await IssueService.resolve(issues, options, comment, true, issuesUpdated);
    setIsOpen(false);
    cancel();
  }, [
    rebookedTabOpen,
    reprotectedTabOpen,
    noChangesMadeTabOpen,
    resolution,
    extraMinutesAdded,
    extraMinutesAvoided,
    travelerContacted,
    pnrUpdated,
    flightsChanged,
    groundTransportationChanged,
    hotelChanged,
    newFlightsOnSameCarrier,
    overnightAvoided,
    ratePaidInUsDollars,
    comment,
    issues,
    cancel,
  ]);

  const handleCancel = useCallback(() => {
    cancel();
  }, [cancel]);

  const commonTabContentProps = {
    resolution,
    setResolution,
    extraMinutesAdded,
    setExtraMinutesAdded,
    extraMinutesAvoided,
    setExtraMinutesAvoided,
    travelerContacted,
    setTravelerContacted,
    pnrUpdated,
    setPnrUpdated,
    flightsChanged,
    setFlightsChanged,
    groundTransportationChanged,
    setGroundTransportationChanged,
    hotelChanged,
    setHotelChanged,
    newFlightsOnSameCarrier,
    setNewFlightsOnSameCarrier,
    ratePaidInUsDollars,
    setRatePaidInUsDollars,
    overnightAvoided,
    setOvernightAvoided,
    comment,
    setComment,
    formValid,
    onSubmit,
    rebookedTabOpen,
    reprotectedTabOpen,
    noChangesMadeTabOpen,
    expiredTabOpen,
  };

  return (
    <Modal isOpen={isOpen} contentStyle={modalContentStyle}>
      <div className="issue-resolution-modal modal-dialog modal-lg">
        <div className="title">
          RESOLVE
          <a href="#" onClick={handleCancel}>
            <i
              id="modalCancelled"
              className="cancel pull-right glyphicon icon-white glyphicon-remove"
            ></i>
          </a>
        </div>

        <div className="row">
          <div className="col-md-12 action-bar">
            <div className="row action-bar-row">
              <div className="col-md-1"></div>
              <div className="col-md-10">
                <TabButton
                  label="REBOOKED"
                  isActive={rebookedTabOpen}
                  onClick={() => tabClicked('rebooked')}
                />
                <TabButton
                  label="REPROTECTED"
                  isActive={reprotectedTabOpen}
                  onClick={() => tabClicked('reprotected')}
                  className='btn-center'
                />
                <TabButton
                  label="NO CHANGES"
                  isActive={noChangesMadeTabOpen}
                  onClick={() => tabClicked('noChangesMade')}
                  className='btn-center'
                />
                <TabButton
                  label="EXPIRED"
                  isActive={expiredTabOpen}
                  onClick={() => tabClicked('expired')}
                />
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>
        </div>

        {rebookedTabOpen && (
          <TabContent
            resolutionOptions={resolutionOptionsRebooked}
            {...commonTabContentProps}
          />
        )}
        {reprotectedTabOpen && (
          <TabContent
            resolutionOptions={resolutionOptionsReprotected}
            {...commonTabContentProps}
          />
        )}
        {noChangesMadeTabOpen && (
          <TabContent
            resolutionOptions={resolutionOptionsNoAction}
            {...commonTabContentProps}
          />
        )}
        {expiredTabOpen && (
          <TabContent
            resolutionOptions={resolutionOptionsExpired}
            {...commonTabContentProps}
          />
        )}
      </div>
    </Modal>
  );
};

export default BatchResolve;
